import styled from "styled-components";

export const AutorizacaoContainer = styled.div({
  marginBottom: "20px",
});
